<template>
  <div :class="`auth ${theme}`">
    <div class="auth__loading-block" v-if="tokenLoading">
      <div class="auth__loading-block-centered">
        <div :class="['auth__logo', { tokenLoading }]"></div>
        <div class="auth__loading-block-text">
          <i class="el-icon-loading" />
          {{ $t(`auth.loader_text`) }}
        </div>
      </div>
    </div>
    <div class="auth__block" v-else>
      <div class="auth__logo"></div>
      <div class="auth__row title">
        <div>{{ $t(`login`) }}</div>
      </div>
      <form id="login-form" v-on:submit.prevent="logIn">
        <div class="auth__row">
          <el-input
            class="r-input"
            name="user[username]"
            :placeholder="$t(`enter_login`)"
            size="mini"
            v-model="userName"
            @keyup.enter.native="logIn"
          >
            <template slot="prepend" />
          </el-input>
        </div>
        <div class="auth__row">
          <el-input
            class="r-input"
            name="user[password]"
            type="password"
            size="mini"
            :placeholder="$t(`enter_pass`)"
            v-model="userPass"
            @keyup.enter.native="logIn"
          >
            <template slot="prepend" />
          </el-input>
        </div>
        <div class="auth__row auth__alert-message" v-if="accessDenied">
          {{ $t("login:access-denied") }}
        </div>
        <div class="auth__row auth__row--button">
          <el-button
            class="r-button auth__button"
            type="primary"
            size="mini"
            :loading="isLoading"
            @click="logIn"
            >{{ $t("login_button") }}</el-button
          >
        </div>
        <!-- <div class="auth__row auth__row--reset">
          <a
            :href="`${url}/password-reset`"
            class="auth__reset-link"
            target="_blank"
            >{{ $t("forgot_pass") }}</a
          >
          <a
            href="https://ritm3.ru/"
            target="_blank"
            class="auth__reset-link"
            >{{ $t("no_account") }}</a
          >
        </div>
        <div class="auth__row">
          <div class="row-separator">
            <span>{{ $t("separator_text") }}</span>
          </div>
        </div>
        <div class="auth__row auth__row--social">
          <div class="auth__social-title">{{ $t("login_social") }}</div>
          <a :href="`${url}/oauth/redirect/vk`" class="auth__social-btn vk"></a>
          <a
            :href="`${url}/oauth/redirect/yandex`"
            class="auth__social-btn yandex"
          ></a>
          <a
            :href="`${url}/oauth/redirect/google`"
            class="auth__social-btn google"
          ></a>
        </div> -->
      </form>
    </div>
    <video autoplay loop id="video-background" muted plays-inline>
      <source src="@/assets/video/bg-video.mp4" type="video/mp4" />
    </video>
  </div>
</template>

<script>
import crypto from "crypto";

import { notifyFactory, toggleBodyTheme } from "@/utils";
import constants from "@/constants/url";
import auth_keys from "@/constants/auth";

const encrypt = text => {
  const iv = "0".repeat(16);
  let cipher = crypto.createCipheriv("aes-256-cbc", auth_keys.AUTH_KEY, iv);
  let crypted = cipher.update(text, "utf-8", "base64");
  crypted += cipher.final("base64");

  return crypted;
};

export default {
  data() {
    return {
      userName: "",
      userPass: "",
      tokenLoading: false,
      isLoading: false,
      url: constants.URL,
      accessDenied: false
    };
  },
  computed: {
    theme() {
      return this.$store.state.theme;
    }
  },
  methods: {
    async changeProfile(id, userId) {
      const dataUserObj = {
        id: userId,
        current_profile_id: id
      };
      try {
        await this.$store.dispatch("PUT_REQUEST", {
          url: `user`,
          data: dataUserObj
        });
      } catch (e) {
        console.log(e);
      }
    },
    async loadConfig() {
      let restUser;
      let currentProfile;
      let profilesTree;
      let user;

      restUser = await this.$store.dispatch("REQUEST", { url: `user` });
      user = restUser.data;
      currentProfile = user.current_profile;
      currentProfile.instance = user.instance;
      profilesTree = user.user_profiles;
      if (!currentProfile) this.changeProfile(profilesTree[0].id, user.id);

      const modules = await this.$store.dispatch("POST_REQUEST", {
        url: "user/modules"
      });
      if (user.unfilled_fields) {
        const findIndex = user.unfilled_fields.indexOf("middle_name");
        if (findIndex > -1) user.unfilled_fields.splice(findIndex, 1);
      }

      if (user.unfilled_fields.length) this.isInfoNotFilled = true;
      this.$store.commit("SET_USER_DATA_BY_TOKEN", {
        user: {
          first_name: user.first_name,
          last_name: user.last_name,
          middle_name: user.middle_name,
          name: user.name,
          role_name: user.role_name,
          user_id: user.id,
          id: user.id,
          position: user.position ? user.position : null,
          email: user.email,
          avatar: user.avatar,
          company: user.company,
          valid_until: user.valid_until
        }
      });

      toggleBodyTheme(currentProfile.theme);

      this.$store.commit("SET_USER_CONFIG", {
        user_config: currentProfile,
        user
      });
      this.$store.commit("SET_USER_MODULES", modules.data);
      this.$store.commit("SET_CURRENT_PROFILE", currentProfile);
      this.$store.commit("SET_PROFILES_TREE", profilesTree);
      this.$store.commit("SET_USER_TASKS_LIST", user.tasks);
    },
    async logIn(demo) {
      this.isLoading = true;

      // TODO: this is demo access for LTM Project - NEED TO DELETE
      if (
        !demo.u &&
        !demo.p &&
        (this.userName === "" || this.userPass === "")
      ) {
        this.isLoading = false;
        this.accessDenied = true;
        return;
      }

      // TODO: this is demo access for LTM Project - NEED TO DELETE
      let userInfo = {
        userName: this.userName || demo.u,
        userPass: encrypt(this.userPass || demo.p)
      };

      try {
        this.tokenLoading = true;
        this.isLoading = false;
        const { access_token } = await this.$store.dispatch("LOG_IN", userInfo);

        await this.loadConfig();
        this.accessDenied = false;
        this.$socket.io.opts.query = { token: access_token };
        this.$socket.open();
        this.tokenLoading = false;
        this.$router.push({ path: "/app/desktop" });
        if (this.isInfoNotFilled) this.showInfoWarning();
      } catch (e) {
        this.isLoading = false;
        this.tokenLoading = false;
        this.accessDenied = true;
      }
      this.isChrome();
    },
    showInfoWarning() {
      const title = "Информация о пользователе не заполнена";
      const message =
        "Заполните, пожалуйста, все поля в Личном кабинете (ФИО, эл. почта, компания)";
      this.$notify(notifyFactory("warning", title, message));
      this.$store.commit("OPEN_MODAL_WINDOW", "account");
      this.isInfoNotFilled = false;
    },
    isChrome() {
      const title = this.$t("info.title");
      const message = this.$t("info.text::isChrome");
      const duration = 5000;
      let isChrome = /Chrome/.test(navigator.userAgent);

      if (!isChrome) {
        setTimeout(
          this.$notify(notifyFactory("info", title, message, duration)),
          100
        );
      }
    }
  },
  async created() {
    // TODO: this is demo access for LTM Project - NEED TO DELETE
    const { LOdemo } = this.$route.query;

    if (LOdemo) {
      this.$store.commit("SET_DEMO_GUEST");
      return this.logIn({ u: "LO_demo_user", p: "5g522fht" });
      // return this.logIn({ u: "Igor", p: "123" });
    }

    if (this.$store.state.auth.token) {
      this.tokenLoading = true;
      try {
        await this.loadConfig();
      } catch (e) {
        console.log(e);
        this.$store.commit("CLEAR_USER_DATA");
        this.tokenLoading = false;
      }
      this.$socket.io.opts.query = { token: this.$store.state.auth.token };
      this.$socket.open();
      this.$router.push({ path: "/app" });
      this.tokenLoading = false;
      if (this.isInfoNotFilled) this.showInfoWarning();
      this.isChrome();
    }
  }
};
</script>

<style lang="scss" src="./login.scss"></style>

<i18n>
{
  "ru": {
    "login": "Вход",
    "enter_login": "Введите логин",
    "enter_pass": "Введите пароль",
    "login_button": "Войти",
    "fail_title": "Некорректные данные",
    "success_title": "Вход",
    "success_message": "Вход выполнен",
    "invalid_data": "Необходимо ввести имя пользователя и пароль.",
    "user_not_exist": "Указанный пользователь не существует.",
    "invalid_pass": "Введен неверный пароль.",
    "load_error": "Ошибка загрузки",
    "load_error_message": "Произошла ошибка при отправке данных.",
    "auth.loader_text": "Загрузка системы...",
    "forgot_pass": "Я забыл пароль",
    "no_account": "У меня нет аккаунта",
    "separator_text": "или",
    "login_social": "Войти через социальные сети",
    "info.title": "Уведомление",
    "info.text::isChrome": "Система находится в стадии активной разработки и на данный момент  корректно работает только в браузере Google Chrome",
    "login:access-denied": "Неверный логин или пароль"
  },
  "en": {
    "login": "Login",
    "enter_login": "Enter username",
    "enter_pass": "Enter password",
    "login_button": "Log in",
    "fail_title": "Invalid data",
    "success_title": "Login",
    "success_message": "Login completed.",
    "invalid_data": "You must enter a user name and password.",
    "user_not_exist": "The specified user does not exist.",
    "invalid_pass": "The password is incorrect.",
    "load_error": "Load error",
    "load_error_message": "Loading canceled",
    "auth.loader_text": "System loading...",
    "forgot_pass": "I forgot my password",
    "no_account": "I dont have an account",
    "separator_text": "or",
    "login_social": "Login via social networks",
    "info.title": "Info",
    "info.text::isChrome": "The system is under active development and currently works only in the Google Chrome.",
    "login:access-denied": "Wrong login or password"
  }
}
</i18n>
